module.exports = __webpack_public_path__ + "media/img/contact-us/offices/offices-section-bg-b34acaa703534528740ed36b99f6f131.svg";